import type { StudentPayload } from '@backend/students-preauth-api/routes/pre/oauth2/token/POST/types'
import jwt_decode from 'jwt-decode'
import { AuthStorage } from '../../utils'

export function useAuthToken() {
  function getAccessTokenPayload(): StudentPayload | null {
    const accessToken = AuthStorage.getAccessToken()

    if (!accessToken) return null
    try {
      return jwt_decode(accessToken) as StudentPayload
    } catch (e) {
      return null
    }
  }

  function isActiveSession(): boolean {
    const tokenPayload = getAccessTokenPayload()
    if (!tokenPayload?.exp) return false
    return Date.now() < tokenPayload.exp * 1000
  }

  function isRefreshableSession(): boolean {
    return !!AuthStorage.getRefreshToken()
  }

  return {
    isRefreshableSession,
    getAccessTokenPayload,
    isActiveSession,
  }
}
